import {Component, Input} from '@angular/core';
import {MemberValue} from '@portal-workspace/grow-shared-library';
import {booleanToYesNo, displaybleDate, notNullUndefined} from '@portal-workspace/grow-shared-library';
import { LiabilitiesSummaryComponent } from './liabilities-summary.component';
import { AssetsSummaryComponent } from './assets-summary.component';
import { MatDividerModule } from '@angular/material/divider';
import { CellComponent } from './cell.component';

import { EllipsisPipe } from '../../pipes/ellipsis.pipe';



@Component({
    selector: 'members-summary',
    template: `

@if (members) {
  @for (member of members; track member; let index = $index) {
    <div class="row">
      <div class="col-12">
        <div class="application-subsection-title">Member {{index + 1}}</div>
      </div>
    </div>
    @if (member.type === 'Entity') {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Type</div>
            <div body>{{member.type}}</div>
          </cell>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation</div>
            <div body>{{member.organisation.name}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation type</div>
            <div body>{{member.organisationType.name}}</div>
          </cell>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ABN</div>
            <div body>{{member.abn}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ACN</div>
            <div body>{{member.acn}}</div>
          </cell>
        </div>
      </div>
    }
    @if (member.type === 'Individual') {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Title</div>
            <div body>{{member.title?.name}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Type</div>
            <div body>{{member.type}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>First name</div>
            <div body><p [innerHTML]="member.firstName | ellipsis:10"></p></div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Last name</div>
            <div body><p [innerHTML]="member.lastName | ellipsis:10"></p></div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Date of birth</div>
            <div body>{{displayableDate(member.dob)}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Residential address</div>
            <div body>{{member.residentialAddress?.address}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      @if (member.propertyOwner) {
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Property Owner</div>
              <div body>{{booleanToYesNo(member.propertyOwner.propertyOwner)}}</div>
            </cell>
          </div>
        </div>
      }
      @if (member.propertyOwner && member.propertyOwner.propertyOwner) {
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Property address</div>
              <div body>{{member.propertyOwner.address?.address}}</div>
            </cell>
          </div>
        </div>
      }
      @if (member.propertyOwner && member.propertyOwner.propertyOwner) {
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Property value</div>
              <div body>{{member.propertyOwner.propertyValue}}</div>
            </cell>
          </div>
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Mortgage value</div>
              <div body>{{member.propertyOwner.mortgageValue}}</div>
            </cell>
          </div>
        </div>
      }
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Guarantor</div>
            <div body>{{booleanToYesNo(member.guarantor)}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Email address</div>
            <div body>{{member.email}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Business landline</div>
            <div body>{{member.mobileNumber}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <assets [assets]="member.personalAssets"></assets>
      <liabilities-summary [liabilities]="member.personalLiabilities"></liabilities-summary>
    }
  }
}



`,
    standalone: true,
    imports: [CellComponent, MatDividerModule, AssetsSummaryComponent, LiabilitiesSummaryComponent, EllipsisPipe]
})
export class MembersSummaryComponent {

  booleanToYesNo = booleanToYesNo;
  displayableDate = displaybleDate;
  notNullUndefined = notNullUndefined;

  @Input({required: true}) members?: MemberValue;

}
